import { Fragment } from "react/jsx-runtime";
import { SplitListContainer } from "../Lists";

export const DataObjectDisplay = ({className, ignore =[], ...props}: { ignore?: string[], className?: string; [key: string]: unknown } ):  JSX.Element => {
  if (!Object?.keys(props)?.length) return <></>

  return (
    <SplitListContainer className={className}>
      {Object.keys(props).map((key) => {
        if (ignore?.includes(key)) return null;
        return (
          <Fragment key={key}>
            <dt>{key}</dt>
            <dd>{String(props[key])}</dd>
          </Fragment>
        ) 
      })}  
    </SplitListContainer>
  )
}